import { render } from "./Subscribers.vue?vue&type=template&id=0c88e0c9&scoped=true"
import script from "./Subscribers.vue?vue&type=script&lang=js"
export * from "./Subscribers.vue?vue&type=script&lang=js"

import "./Subscribers.vue?vue&type=style&index=0&id=0c88e0c9&scoped=true&lang=css"

import exportComponent from "F:\\ssd_backup\\OpenServer\\domains\\paygate.admin-panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c88e0c9"]])

export default __exports__